import { render, staticRenderFns } from "./ComponentRenderDetails.vue?vue&type=template&id=5abb6c01&scoped=true&"
import script from "./ComponentRenderDetails.vue?vue&type=script&lang=js&"
export * from "./ComponentRenderDetails.vue?vue&type=script&lang=js&"
import style0 from "./ComponentRenderDetails.vue?vue&type=style&index=0&id=5abb6c01&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5abb6c01",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/akryum/Projects/vue-devtools/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5abb6c01')) {
      api.createRecord('5abb6c01', component.options)
    } else {
      api.reload('5abb6c01', component.options)
    }
    module.hot.accept("./ComponentRenderDetails.vue?vue&type=template&id=5abb6c01&scoped=true&", function () {
      api.rerender('5abb6c01', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@vue-devtools/app-frontend/src/views/perf/ComponentRenderDetails.vue"
export default component.exports